import React from 'react'
import PropTypes from 'prop-types'

const DEFAULT_SIZE = 24

const Icon = ({
    icon: IconComponent,
    color = 'currentColor',
    width = DEFAULT_SIZE,
    height = DEFAULT_SIZE,
    className = '',
    style = {},
    ...rest
}) => {
    return (
        <IconComponent
            width={width}
            height={height}
            color={color}
            className={`Icon ${className}`}
            style={style}
            {...rest}
        />
    )
}

Icon.propTypes = {
    icon: PropTypes.elementType,
    color: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    className: PropTypes.string,
    style: PropTypes.object,
}

export default Icon
